"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTable = void 0;
/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */
const common_1 = require("@angular/common");
const core_1 = require("@angular/core");
const ngx_datatable_1 = require("@siemens/ngx-datatable");
const lodash_1 = require("lodash");
const config_service_1 = require("../../../shared/config/config.service");
const web_socket_service_1 = require("../../../shared/connections/web-socket.service");
const users_service_1 = require("../../../shared/users/users.service");
const enums_1 = require("../@shared-types/vehicle/enums");
const vehicle_1 = require("../shared/models/vehicle/vehicle");
const vehicle_export_service_1 = __importDefault(require("../shared/services/export/vehicle-export.service"));
const filtering_1 = require("../shared/services/filtering");
const object_1 = __importDefault(require("../shared/services/object"));
const table_component_1 = require("../table-component/table.component");
const interface_service_1 = require("../../../shared/interface/interface.service");
const permissions_service_1 = require("../../../components/authorization/permissions.service");
const user_1 = require("../@types/user");
const customer_1 = require("../shared/models/customer/customer");
const filter_1 = require("./filter");
let VehicleTable = class VehicleTable extends table_component_1.GenericTableComponent {
    constructor(objectService, filteringService, permissionService, vehicle, configService, socketService, location, usersService, vehicleExportService, interfaceService, customerModel) {
        super(filteringService, objectService, 'vehicleTable');
        this.vehicle = vehicle;
        this.configService = configService;
        this.socketService = socketService;
        this.location = location;
        this.usersService = usersService;
        this.vehicleExportService = vehicleExportService;
        this.interfaceService = interfaceService;
        this.customerModel = customerModel;
        this.ColumnMode = ngx_datatable_1.ColumnMode;
        this.SortType = ngx_datatable_1.SortType;
        this.detailVehicleId = null;
        this.newVehicles = true;
        this.dummyVehicle = false;
        this.importantComments = null;
        this.vehicleFilter = {};
        this.res = null;
        /** `permission` attribute directive is not usable in Angular
         * components. As as temp workaround we use this to toggle UI elements. */
        this.sellerPermission = false;
        this.dataReady = false;
        this.sortBy = 'modelData.make';
        this.initTable = () => __awaiter(this, void 0, void 0, function* () {
            if (this.location.path().includes('sold')) {
                this.newVehicles = false;
            }
            /** Table is called with a `DummyVehicle`, meaning it is only called
             * to directly go to a `DummyVehicle`'s form eg. for generating an offer.
             * We therefore only need to retreive the `DummyVehicle` for handing it
             * over to the form and not all vehicles in the table. */
            if (this.location.path().includes('dummy')) {
                this.dummyVehicle = true;
                /** Get `DummyVehicle` */
                const selectedId = this.interfaceService.getRouteParams().id;
                this.detailVehicleId = selectedId;
            }
        });
        this.getMongoData = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.initialized)
                return;
            this.dataReady = false;
            const filter = {
                'vehicleData.inventory.state': {
                    // eslint-disable-next-line max-len
                    $in: this.newVehicles ? [enums_1.EInventoryState.Ordered, enums_1.EInventoryState.Stock] : [enums_1.EInventoryState.Sold],
                },
            };
            const req = {
                filter: Object.assign(Object.assign({}, filter), this.getMongoFilter()),
                comparisonFilter: filter,
                limit: this.limit,
                page: this.currentPage,
                sortBy: this.sortBy,
                sortDirection: this.sortDirection,
            };
            /** If user sorts by any date we switch direction, because it makes more sense. */
            if (req.sortBy.toLowerCase().includes('date')) {
                req.sortDirection = req.sortDirection === 1 ? -1 : 1;
            }
            const res = yield this.vehicle.filter(req);
            if (this.interfaceService.getRouteParams().id) {
                const selectedId = this.interfaceService.getRouteParams().id;
                this.detailVehicleId = selectedId;
            }
            this.res = res;
            this.dataReady = true;
        });
        /** Gets called from Rail Component when user switches
         * selection, but also on init. */
        this.switchSoldVehicles = (selectedItem) => {
            this.newVehicles = selectedItem === 'Bestand';
            this.getMongoData();
        };
        this.selectRow = (event) => {
            if (!this.res)
                return;
            const params = this.interfaceService.getRouteParams();
            const vehicleId = String(event.selected[0]._id);
            if (this.dummyVehicle) {
                this.interfaceService.navigateToUrl('/vehicles/dummy', Object.assign(Object.assign({}, params), { id: vehicleId }));
            }
            else if (this.newVehicles) {
                this.interfaceService.navigateToUrl('/vehicles/stock', Object.assign(Object.assign({}, params), { id: vehicleId }));
            }
            else {
                this.interfaceService.navigateToUrl('/vehicles/sold', Object.assign(Object.assign({}, params), { id: vehicleId }));
            }
            this.detailVehicleId = String(event.selected[0]._id);
        };
        this.hideDetailedVehicle = () => {
            if (this.newVehicles) {
                this.location.go('/vehicles/stock');
            }
            else {
                this.location.go('/vehicles/sold');
            }
            this.detailVehicleId = null;
        };
        this.onPopState = () => {
            if (this.detailVehicleId)
                this.hideDetailedVehicle();
        };
        this.downloadCsv = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.res)
                return;
            const filter = Object.assign({ 'vehicleData.inventory.state': {
                    // eslint-disable-next-line max-len
                    $in: this.newVehicles ? [enums_1.EInventoryState.Ordered, enums_1.EInventoryState.Stock] : [enums_1.EInventoryState.Sold],
                } }, this.getMongoFilter());
            const req = {
                filter,
                limit: this.res.filteredCount,
                page: 1,
                sortBy: this.sortBy,
                sortDirection: this.sortDirection,
            };
            const res = yield this.vehicle.filter(req);
            this.vehicleExportService.exportCsv(res.data, 'autoboard-fahrzeuge.csv');
        });
        this.showImportantComments = (vehicleId) => {
            this.importantComments = vehicleId;
        };
        this.hideImportantComments = () => {
            this.importantComments = null;
        };
        this.getTableData = () => __awaiter(this, void 0, void 0, function* () { });
        this.initTable();
        this.socketService.on('sales_updateVehicleData', (payload) => {
            var _a;
            if (!this.res)
                return;
            const parsed = JSON.parse(payload);
            let vehicleToUpdate = (_a = this.res) === null || _a === void 0 ? void 0 : _a.data.find((v) => v._id.toString() === parsed.vehicleId);
            if (!vehicleToUpdate)
                return;
            vehicleToUpdate = this.objectService
                .mergeObjects(vehicleToUpdate, parsed.data);
            /** Refresh all object references, to force table redraw */
            this.res.data = (0, lodash_1.cloneDeep)(this.res.data);
        });
        if (permissionService.isPermitted([user_1.UserRole.ADMIN, user_1.UserRole.SELLER_PLUS])) {
            this.sellerPermission = true;
        }
        this.filters = (0, filter_1.getTableFilter)(configService, customerModel, usersService);
        this.loadFiltersFromStorage();
    }
};
__decorate([
    (0, core_1.HostListener)('window:popstate', ['$event']),
    __metadata("design:type", Object)
], VehicleTable.prototype, "onPopState", void 0);
VehicleTable = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-table',
        templateUrl: require('./vehicle-table.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _a : Object, typeof (_b = typeof filtering_1.FilteringService !== "undefined" && filtering_1.FilteringService) === "function" ? _b : Object, typeof (_c = typeof permissions_service_1.PermissionsService !== "undefined" && permissions_service_1.PermissionsService) === "function" ? _c : Object, typeof (_d = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _d : Object, typeof (_e = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _e : Object, typeof (_f = typeof web_socket_service_1.SocketService !== "undefined" && web_socket_service_1.SocketService) === "function" ? _f : Object, typeof (_g = typeof common_1.Location !== "undefined" && common_1.Location) === "function" ? _g : Object, typeof (_h = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _h : Object, typeof (_j = typeof vehicle_export_service_1.default !== "undefined" && vehicle_export_service_1.default) === "function" ? _j : Object, typeof (_k = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _k : Object, typeof (_l = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _l : Object])
], VehicleTable);
exports.VehicleTable = VehicleTable;
